import React, { useEffect } from 'react';
import {useSelector, useDispatch} from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Cookies } from 'react-cookie';
import { CHANGE_SUBJECT, AUTHORITIES } from 'constants';

export const SubjectChange = () => {
    const initialRoles = useSelector((state) => state.authentication.initialRoles);
    const {forLegalIps, forLegalIzvor, forPersonOib, toLegalIps, toLegalIzvor} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(()=>{
      console.log(initialRoles);
      if (!forPersonOib && !forLegalIps) {
        navigate("/");
        return;
      }
        dispatch({
          type: AUTHORITIES,
          payload:initialRoles,
        });
        
        dispatch({type: CHANGE_SUBJECT,
          payload: {
            forLegalIps,
            forLegalIzvor,
            forPersonOib,
            toLegalIps,
            toLegalIzvor,
          }
        });
       const cookie = new Cookies(document.cookie);
       const decoded = cookie.get("token");
       localStorage.setItem("token",decoded);
        navigate('/dash',{state: {redirect:true}});
    },[]);


    return (
    <>
    </>
  )
}
